var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "right-profile-wrap"
  }, [_vm._v(" 12333 ")]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };